export default __webpack_public_path__ + "static/media/p-notstart.54aa9c82.svg";